import ApiService from '../api.service'

export interface TarefaDesenvolvimento {
    /** Número da issue — usado como row id na grid. */
    id: number
    referencia: string
    url: string
    titulo: string
    status: string
    cobranca: boolean
    createdAt: string
}

export const desenvolvimento = new ApiService<TarefaDesenvolvimento>(
    'desenvolvimento/tarefas',
)
